import Request from './request';

export default class ApiService {
  static getAdditionalTileData(obfuscatedId: string): Promise<any> {
    const url = `/api/content_blocks/tile_container/${obfuscatedId}/additional_tile_data/`;

    return Request.getHelper(url);
  }

  static saveContentForLater(params: object): Promise<any> {
    const url = `/settings/saved-content/`;

    return Request.postHelperWithAuthRedirect(url, params);
  }

  static saveContentForLaterWithDomain(params: object, contentDomainId?: string): Promise<any> {

    const baseUrl = `/settings/saved-content/`;
    const url = contentDomainId ? `${baseUrl}?d=${contentDomainId}` : baseUrl;

    return Request.postHelper(url, params);
  }
}
